<!-- 查询模板 -->
<template>
    <div class="container">
        <Table :columns="columnTable" :data="dataTable" border>
            <template slot-scope="{ index }" slot="id">
                <div>{{ index + 1 }}</div>
            </template>
            <template slot-scope="{ row }" slot="cover_img">
                <div class="flex-c">
                    <div class="tooltip_div">
                        <Tooltip v-if="row.cover_img" theme="light" transfer>
                            <img class="width_37_54 cursor-p" :src="row.cover_img"/>
                            <template slot="content">
                                <img class="width_200_375" :src="row.cover_img"/>
                            </template>
                        </Tooltip>
                    </div>
                </div>
            </template>
            <template slot-scope="{ row }" slot="operate">
                <div class="flex-sa">
                    <Button v-if="row.merchant_query_template_id" type="primary" ghost label="small" @click="linkDiy(row)">编辑</Button>
                    <div class="width_54">
                        <div class="t-color" v-if="row.merchant_query_template_id">使用中</div>
                        <Button v-else type="warning" ghost label="small" @click="goUse(row)">使用</Button>
                    </div>
                </div>
            </template>
        </Table>
        <div class="ta-r mt-24">
            <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
        </div>
    </div>
</template>

<script>
import { 
    template_query_template, 
    template_modify_use,
} from '@/api/index';
import VueQr from 'vue-qr'
export default {
    components: { VueQr },
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnTable: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "预览图", slot: "cover_img", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "250px" },
            ],
            dataTable: [],
        };
    },
    mounted() {
        this.dataTable = [];
        this.getList();
    },
    methods: {
        getList() {
            template_query_template(this.storePrams).then((res) => {
                this.dataTable = res.data.list;
                this.total = res.data.count;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // Page
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 使用
        goUse(row) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: '确定要使用此模板（' + row.title + '）？',
                onOk: () => {
                    template_modify_use({ id: row.id }).then((res) => {
                        that.getList();
                        that.$Message.success(res.msg);
                        that.$router.push({ path: `/admin/formwork/editDiy?id=${row.id}&diy_id=2` });
                    })
                    .catch((res) => {
                        that.$Message.error(res.msg);
                    });
                },
                onCancel: () => {
                },
            });
        },
        // 跳转DIY
        // diy_id == 2（查询模板）
        linkDiy(row){
            this.$router.push({ path: `/admin/formwork/editDiy?id=${row.id}&diy_id=2` });
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.tooltip_div {
    margin: 12px;
    padding-top: 3px;
    width: 60px;
    height: 60px;
    background: #fbfbfb;
    border: 1px solid #eaeaea;
}
.width_37_54 {
    width: 37px;
    height: 54px;
}
.width_200_375 {
    width: 200px;
    height: 375px;
}
.width_54 {
    width: 54px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>